import React from 'react';

const features = [
  { icon: '⚖️', title: 'Custom Environments', desc: 'Get the exact stack you need, no compromises.' },
  { icon: '🚀', title: 'Git-Based Deployments', desc: 'Push, build, and ship. No magic, just logic.' },
  { icon: '🤝', title: 'Embedded Engineers', desc: 'Talk to someone who understands your code.' },
  { icon: '🛡️', title: 'Secure Local Infrastructure', desc: 'Milwaukee datacenter, no hidden clouds.' },
];

const ValueSnapshot = () => (
  <div className="py-16 bg-gray-100">
    <h2 className="text-3xl font-bold text-center text-blue-900 mb-8">Built for Builders. Powered by People.</h2>
    <div className="max-w-5xl mx-auto grid gap-8 sm:grid-cols-2 lg:grid-cols-4 px-8">
      {features.map((f) => (
        <div key={f.title} className="text-center p-4 bg-white shadow-lg rounded-lg">
          <div className="text-4xl mb-4">{f.icon}</div>
          <h3 className="font-semibold text-xl mb-2 text-blue-900">{f.title}</h3>
          <p className="text-gray-700 text-sm">{f.desc}</p>
        </div>
      ))}
    </div>
  </div>
);

export default ValueSnapshot;
